import { Model } from 'es6/components/model'
import { entryScriptName } from 'init/entry-script-name'
import { Defaults } from 'es-decorators'

/**
 * Модель прогресс бара.
 */
@Defaults({
  urlRoot: () => {
    return `${entryScriptName}/api/v4/order-progress`
  },
  additionalOptions: ['settlement', 'currency'],
})
export class OrderProgress extends Model {
  /**
   * Изменяет строку с урлом.
   * @returns {string} Строка с урлом.
   */
  url () {
    const settlementId = this.settlement.get('settlement_id')
    const currency = this.currency.name
    let url = super.url()
    let fragment = url.indexOf('?') === -1 ? '?' : '&'
    fragment += $.param({ settlement_id: settlementId, currency })
    url += fragment
    return url
  }

  /**
   * Изменяет ответ.
   * @param {Object} resp Необработанный ответ.
   * @returns {string} Обработанный ответ.
   */
  parse (resp) {
    return resp.items
  }
}
